window.cartType = 'mini-cart';
/* After Customall adds to cart via its own AJAX, open the theme's Dawn /
   Memorelo <cart-drawer> (replaces SlideCartHQ, which the merchant disables
   in the app admin). Regular + Customily products already use Dawn's drawer
   natively via the theme add-to-cart button; only Customall routed through
   this callback, so this is the single spot to re-point.
   Fetches fresh cart-drawer + cart-icon-bubble section HTML and hands it to
   Dawn's CartDrawer.renderContents (which refreshes line items and opens). */
window.addToCartCallback = (cart) => {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) {
    /* Drawer absent (cart_type still 'notification'?) — fall back to SlideCart
       if it happens to be installed, otherwise no-op. */
    if (typeof window.SLIDECART_OPEN === 'function') {
      if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE(cart);
      window.SLIDECART_OPEN();
    }
    return;
  }
  /* Fetch section HTML from the CART url (never edge-cached, unlike "/", which
     Cloudflare can serve as cached homepage HTML → .json() throws → empty drawer)
     and render it into the drawer. Customall's add can momentarily race the
     storefront cart commit, so if the drawer comes back EMPTY while the cart
     should have items, re-fetch a few times before giving up. cache:'no-store'
     stops the browser reusing a stale (empty) cart response. */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartUrl = (window.routes && window.routes.cart_url) || (root.replace(/\/$/, '') + '/cart');
  var expectItems = !cart || cart.item_count == null || cart.item_count > 0;
  function refresh(attempt) {
    fetch(cartUrl + '?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections && sections['cart-drawer'] && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ id: (cart && cart.id) || null, sections: sections });
        } else if (typeof drawer.open === 'function') {
          drawer.open();
        }
        if (attempt < 3 && expectItems && drawer.querySelectorAll) {
          setTimeout(function () {
            if (drawer.querySelectorAll('.cart-item').length === 0) refresh(attempt + 1);
          }, 450);
        }
      })
      .catch(function () {
        if (attempt < 3) { setTimeout(function () { refresh(attempt + 1); }, 450); }
        else if (typeof drawer.open === 'function') { drawer.open(); }
      });
  }
  refresh(1);
};

/* Gallery swap on Customall products.
   - Initial: Customall live preview shown (#artwork-preview), theme
     main slider hidden by CSS default. Thumbnails always visible.
   - User clicks a thumbnail: show theme main slider (so the chosen
     product photo is visible), hide Customall preview.
   - User clicks/changes a personalisation control: swap back to
     Customall preview, hide theme main. */
(function () {
  var LOG = '[gallery-swap]';
  var wired = false;

  function getEls() {
    return {
      preview: document.querySelector('#artwork-preview'),
      mainSlider: document.querySelector(
        '.product__media-wrapper media-gallery slider-component[id^="GalleryViewer"]'
      ),
      thumbs: document.querySelector(
        '.product__media-wrapper media-gallery slider-component[id^="GalleryThumbnails"]'
      ),
      personalization: document.querySelector('.ctm-customize-product'),
    };
  }

  function showCustomallPreview() {
    var els = getEls();
    if (els.preview) els.preview.classList.remove('customall-preview-hidden');
    if (els.mainSlider) els.mainSlider.classList.remove('theme-main-shown');
  }

  function showThemeMain() {
    var els = getEls();
    if (els.preview) els.preview.classList.add('customall-preview-hidden');
    if (els.mainSlider) els.mainSlider.classList.add('theme-main-shown');
  }

  function wire() {
    if (wired) return;
    var els = getEls();
    if (!els.preview || !els.mainSlider || !els.thumbs || !els.personalization) return;
    wired = true;

    /* Thumbnail click → show theme main image (with chosen slide). */
    els.thumbs.addEventListener('click', showThemeMain, { capture: true });

    /* Personalisation interaction → show Customall live preview. */
    ['click', 'change', 'input'].forEach(function (evt) {
      els.personalization.addEventListener(evt, showCustomallPreview, { capture: true });
    });

    /* Default state: Customall preview visible (CSS handles this). */
    showCustomallPreview();
    console.log(LOG, 'wired: thumb→theme, personalisation→preview');
  }

  function init() {
    wire();
    if (wired) return;
    var observer = new MutationObserver(wire);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Customall replaces the main product price HTML with a stripped-down
   <span class="money">€27.00</span> in English number format. Re-format it
   to Bulgarian comma-decimal so the price reads like Customily.
   (The lev "(X.XX лв)" suffix was removed on 2026-08-10 — dual EUR/BGN
   display is no longer required in Bulgaria. EUR only.) */
(function () {
  var LOG = '[price-formatter]';

  function format(num) {
    return num.toFixed(2).replace('.', ',');
  }

  function restorePrice() {
    var priceWrapper = document.querySelector('.price.price--large');
    if (!priceWrapper) return;

    var moneySpan = priceWrapper.querySelector('.price__sale .money, .money');
    if (!moneySpan) return;

    /* Already in Bulgarian comma format — nothing to do. */
    if (moneySpan.getAttribute('data-price-formatted')) return;

    /* Parse the EUR price out of the visible text. Match digits + decimal. */
    var match = (moneySpan.textContent || '').match(/[\d.,]+/);
    if (!match) return;
    var eur = parseFloat(match[0].replace(',', '.'));
    if (!isFinite(eur)) return;

    /* Rewrite the visible price text to Bulgarian comma-decimal format. */
    moneySpan.textContent = '€' + format(eur);
    moneySpan.setAttribute('data-price-formatted', 'true');
    console.log(LOG, 'price formatted to', moneySpan.textContent);
  }

  function init() {
    restorePrice();
    /* Watch for re-renders (variant change, etc.) */
    var observer = new MutationObserver(restorePrice);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    setTimeout(function () { observer.disconnect(); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Two tweaks for Customall product pages:
   1. Move .cart-qty (Customall's quantity dropdown) ABOVE .ctm-customize-product
      so it matches the Customily layout (qty before personalization options).
   2. Replace the raw <select> inside .cart-qty with a +/− stepper UI that
      drives the underlying select via change events — Customall keeps reading
      its own form, but the user sees a stepper matching the Dawn theme look. */
(function () {
  var LOG = '[customall-fixes]';
  var QUANTITY_SELECTOR = '.cart-qty';
  var CARD_SELECTOR = '.ctm-customize-product';

  var attempts = 0;
  var loggedOnce = false;

  function moveQuantityAboveCard() {
    var quantity = document.querySelector(QUANTITY_SELECTOR);
    var card = document.querySelector(CARD_SELECTOR);
    if (!quantity || !card) return false;
    if (card.previousElementSibling === quantity) return true;
    try {
      card.parentNode.insertBefore(quantity, card);
      console.log(LOG, 'moved .cart-qty before card');
      return true;
    } catch (e) {
      console.error(LOG, 'move failed:', e);
      return false;
    }
  }

  function injectStepper() {
    var cartQty = document.querySelector('.cart-qty');
    if (!cartQty) return;
    var select = cartQty.querySelector('select.form-select, select');
    if (!select) return;
    /* Already injected? (re-renders may remove our stepper — re-inject below.) */
    if (cartQty.querySelector('.cart-qty-stepper')) return;

    var stepper = document.createElement('div');
    stepper.className = 'cart-qty-stepper';

    var minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'cart-qty-stepper__btn cart-qty-stepper__btn--minus';
    minus.setAttribute('aria-label', 'Намали количество');
    minus.innerHTML = '<svg viewBox="0 0 10 2" width="10" height="2" aria-hidden="true"><rect width="10" height="2" rx="1" fill="currentColor"/></svg>';

    var valueEl = document.createElement('span');
    valueEl.className = 'cart-qty-stepper__value';

    var plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'cart-qty-stepper__btn cart-qty-stepper__btn--plus';
    plus.setAttribute('aria-label', 'Увеличи количество');
    plus.innerHTML = '<svg viewBox="0 0 10 10" width="10" height="10" aria-hidden="true"><rect x="4" width="2" height="10" rx="1" fill="currentColor"/><rect y="4" width="10" height="2" rx="1" fill="currentColor"/></svg>';

    stepper.appendChild(minus);
    stepper.appendChild(valueEl);
    stepper.appendChild(plus);
    cartQty.appendChild(stepper);

    function refresh() {
      var opt = select.options[select.selectedIndex];
      valueEl.textContent = opt ? (opt.textContent || '').trim() : '1';
      minus.disabled = select.selectedIndex <= 0;
      plus.disabled = select.selectedIndex >= select.options.length - 1;
    }

    function changeBy(delta) {
      var newIdx = select.selectedIndex + delta;
      if (newIdx < 0 || newIdx >= select.options.length) return;
      select.selectedIndex = newIdx;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.dispatchEvent(new Event('input', { bubbles: true }));
      refresh();
    }

    minus.addEventListener('click', function () { changeBy(-1); });
    plus.addEventListener('click', function () { changeBy(1); });
    select.addEventListener('change', refresh);
    refresh();
    console.log(LOG, 'stepper injected');
  }

  function tick() {
    attempts++;
    moveQuantityAboveCard();
    injectStepper();

    if (!loggedOnce) {
      var cartQty = document.querySelector('.cart-qty');
      var card = document.querySelector('.ctm-customize-product');
      if (cartQty && card) {
        loggedOnce = true;
        console.log(LOG, 'init complete (cart-qty + card present)');
      }
    }
  }

  function init() {
    console.log(LOG, 'init');
    tick();
    var poll = setInterval(function () {
      tick();
      if (attempts >= 100) {
        clearInterval(poll);
        console.log(LOG, 'poll finished');
      }
    }, 200);

    /* MutationObserver catches late re-renders (variant change, modal close). */
    var observer = new MutationObserver(function () { tick(); });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Bulgarian localisation for Customall labels.
   The app ships English labels ("Preview", "Add to cart", "Quantity")
   that aren't always translated by the merchant's Customall Translations
   panel. Rather than waiting for Customall's own i18n flow, replace the
   visible text directly. Watches for late re-renders for ~60s so variant
   changes / modal mounts don't revert. "Добави в количка" matches the
   theme's bg-BG.json add_to_cart string. */
(function () {
  var TRANSLATIONS = [
    { selector: 'button.btn-preview', en: 'Preview', bg: 'Преглед' },
    { selector: 'button.btn-add-to-cart', en: 'Add to cart', bg: 'Добави в количка' },
    { selector: '.cart-qty > label', en: 'Quantity', bg: 'Количество' },
  ];

  function findTextNode(el) {
    /* For non-button elements (e.g. <label>), the text sits directly on
       the element — return it as-is. For buttons with nested spans, pick
       the deepest text-bearing node. */
    if (el.tagName !== 'BUTTON' || el.children.length === 0) return el;
    var candidates = el.querySelectorAll('span, div');
    for (var i = 0; i < candidates.length; i++) {
      var t = (candidates[i].textContent || '').trim();
      if (t && candidates[i].children.length === 0) return candidates[i];
    }
    return el;
  }

  function translateAll() {
    TRANSLATIONS.forEach(function (entry) {
      document.querySelectorAll(entry.selector).forEach(function (el) {
        var target = findTextNode(el);
        var current = (target.textContent || '').trim();
        if (current === entry.bg) return;
        if (current === entry.en || /^(preview|add to cart|quantity)$/i.test(current)) {
          target.textContent = entry.bg;
        }
      });
    });
  }

  function init() {
    translateAll();
    var observer = new MutationObserver(translateAll);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    setTimeout(function () { observer.disconnect(); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Tag <body> with `cart-open` whenever Dawn's <cart-drawer> is active
   or SlideCartHQ is visible — companion CSS in customall-v2.css then
   hides Customall's #artwork-preview and the product media wrapper so
   they can't paint above the drawer (stacking-context quirks let them
   escape a plain z-index fix). Mirrors the same logic in
   customily-script-v2.js used for non-Customall products. */
(function () {
  /* "Open" means actually ON-SCREEN — not merely present in the DOM.
     SlideCartHQ keeps its <div class="slidecarthq"> mounted at all times,
     parked just off the right edge (left ≈ window.innerWidth) when closed,
     with display:flex / visibility:visible. A naive display/visibility +
     width/height check therefore reads a CLOSED drawer as visible and pins
     body.cart-open permanently — which hides the product gallery. Require
     the panel's box to overlap the viewport instead. */
  function isOnScreen(el) {
    if (!el) return false;
    var s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    if (r.width <= 0 || r.height <= 0) return false;
    return r.left < window.innerWidth - 10 && r.right > 10 &&
           r.top < window.innerHeight - 10 && r.bottom > 10;
  }

  function update() {
    var slidecartOpen = isOnScreen(document.querySelector('.slidecarthq'));
    var dawnCartOpen = !!document.querySelector('cart-drawer.active');
    document.body.classList.toggle('cart-open', slidecartOpen || dawnCartOpen);
  }

  function watch() {
    update();
    var observer = new MutationObserver(update);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden', 'hidden'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();

/* Bulgarian translation of Customall's English photo-UPLOAD instructions.
   On photo products the upload field (label "Choose and upload your photo…",
   "Select Image" button, and the bullet hints below it) ships untranslated
   English. These render only AFTER the shopper picks an earlier option
   (e.g. "Брой животни"), so the field can appear long after page load —
   hence a generous 5-minute observe window. We walk the personalization
   card's TEXT NODES and swap exact English strings for Bulgarian, which is
   safe (no partial matches, no element clobbering). The merchant could also
   set these in Customall admin → Translations; this is the same client-side
   fallback used for the Preview / Add-to-cart / Quantity labels above. */
(function () {
  var MAP = {
    'Choose and upload your photo…': 'Изберете и качете снимка…',
    'Choose and upload your photo...': 'Изберете и качете снимка...',
    'Select Image': 'Избери снимка',
    'Please choose a high-quality image for the best looking product.':
      'Моля, изберете висококачествена снимка за най-добър резултат.',
    'You can adjust the image yourself by using modify buttons':
      'Можете сами да нагласите снимката с бутоните за редактиране',
    'Click the EDIT button to re-adjust your image':
      'Натиснете бутона EDIT, за да коригирате снимката',
    'You can re-upload other photos by click the CHANGE button':
      'Можете да качите друга снимка с бутона CHANGE',
  };

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim(); }

  function translate() {
    var card = document.querySelector('.ctm-customize-product');
    if (!card) return;
    var walker = document.createTreeWalker(card, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var key = norm(node.nodeValue);
      if (key && MAP[key]) node.nodeValue = MAP[key];
    }
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; translate(); }, 200);
  }

  function init() {
    schedule();
    var observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    /* Field is conditional on shopper interaction — keep watching 5 min. */
    setTimeout(function () { observer.disconnect(); }, 300000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
